var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.open)?_c('div',[_c('spinner-component'),_c('div',[(_vm.open)?_c('router-component'):_vm._e()],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }